import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { login } from "../api/auth";
import "./AuthPage.css";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const response = await login(username, password);
      if (!response.data?.token) throw new Error("The server did not return a sign-in token.");
      onLogin(response.data.token, username);
      navigate("/", { replace: true });
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message || "Unable to sign in. Check your details and try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="auth-page">
      <Link className="auth-brand" to="/">
        <span className="brand-mark">Y</span>
        <span>Yants</span>
      </Link>
      <section className="auth-panel">
        <p className="auth-eyebrow">YANTS WORKSPACE</p>
        <h1>Welcome back</h1>
        <p className="auth-intro">Sign in to catch up with your community.</p>
        {location.state?.registered && <p className="auth-success" role="status">Account created. Sign in to continue.</p>}
        {error && <p className="auth-error" role="alert">{error}</p>}
        <form className="auth-form" onSubmit={handleSubmit}>
          <label htmlFor="login-email">Email</label>
          <input autoComplete="username" id="login-email" onChange={(event) => setUsername(event.target.value)} required type="email" value={username} />
          <label htmlFor="login-password">Password</label>
          <input autoComplete="current-password" id="login-password" onChange={(event) => setPassword(event.target.value)} required type="password" value={password} />
          <button disabled={isSubmitting} type="submit">{isSubmitting ? "Signing in..." : "Sign in"}</button>
        </form>
        <p className="auth-switch">New to Yants? <Link to="/register">Create an account</Link></p>
        <Link className="auth-back-link" to="/">Back to channels</Link>
      </section>
    </main>
  );
}
